module.exports = __webpack_public_path__ + "media/images/proof_links/linkedin-edeba0a646f244966c8841a6fa84c9d8.svg";